import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useJourneyAuth } from "../auth/AuthContext";
import { readMembershipActivation } from "../config";
import "./membership-enrollment-modal.css";

/**
 * Blocks Journey browsing while membership enrollment is incomplete.
 * Survives new tabs/windows on this origin via localStorage.
 */
export default function MembershipActivationGate() {
  const { pathname } = useLocation();
  const { session } = useJourneyAuth();
  const [lock, setLock] = useState(() => readMembershipActivation());

  useEffect(() => {
    function refresh() {
      setLock(readMembershipActivation());
    }
    refresh();
    window.addEventListener("storage", refresh);
    window.addEventListener("focus", refresh);
    return () => {
      window.removeEventListener("storage", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, [pathname]);

  const blocked = lock?.status === "locked" && pathname !== "/pricing" && !session;
  if (!blocked) return null;

  return (
    <div className="mem-lock-gate" role="alertdialog" aria-labelledby="mem-lock-title">
      <div className="mem-lock-gate__card">
        <h2 id="mem-lock-title">Membership activation required</h2>
        <p>
          Your enrollment is not complete. Payment and agreement acceptance are required before
          system access. Complete enrollment on the Pricing page.
        </p>
        <Link className="pricing-cta" to="/pricing">
          Return to Pricing
        </Link>
      </div>
    </div>
  );
}
